import type { Step } from '../types/step';
import type { AppData } from '../../types/app_data';
import { AppStepSection, StepCategory } from '../../types/app_data';
import { addCarYearQueryParams } from '../common/addcars';

export const AddCarYearStep: Step = {
  id: 'addCarYear',
  pathname: '/addcaryear',
  queryParams: addCarYearQueryParams,
  excludeFromProgressCalculation: (appData) => !!appData.addingNewCar,

  canShow: (appData) => {
    if (appData.addingNewCar) {
      return true;
    }

    if (appData.stepSection === AppStepSection.Challenge) {
      return !appData.cars || appData.cars.length === 0;
    }

    if (appData.isFromMAL) {
      return false;
    }
    if (appData.isOnboardingLite) {
      return false;
    }

    // If user is from partner signup and already prefilled cars, skip this step
    if (
      appData.signupParams?.partnerSignup &&
      !!appData.partnerSkippableData?.cars &&
      appData.partnerSkippableData.cars.length > 0
    ) {
      return false;
    }

    return (
      !!appData.selectedService?.insurance && (!appData.searchPolicyData || appData.searchPolicyData.cars.length === 0)
    );
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => {
    if (appData.signupParams?.needNNOInsurance) {
      return true;
    }
    if (appData.initialCarAddCarByVin) {
      return true;
    }

    return appData.addingNewCar ? !!appData.addingNewCar.car.year : !!appData.signupParams?.initialCar?.year;
  },
  category: () => StepCategory.Cars,
  specialNextStep: {
    /**
     * enable: when user chooses not to go through the nno flow, next step go to add car step.
     */
    enable: (appData) => appData.signupParams?.needNNOInsurance === true,
    nextStepId: 'nnoPrompt',
  },
};
